import React from 'react';
import Icon from '../../components/Icon';
import './NewMessagesPill.css';

/**
 * NewMessagesPill — floats above the composer when the user has scrolled away
 * from the bottom and new messages have arrived. Tap → ChatRegion scrolls to
 * the anchor and resets the unread count.
 */
function NewMessagesPill({ count, onClick }) {
  if (!count || count <= 0) return null;
  const label =
    count === 1 ? '1 new message' : `${count} new messages`;
  return (
    <button
      type="button"
      className="glacier-new-pill"
      onClick={onClick}
      aria-label={`${label}, jump to latest`}
      data-testid="new-messages-pill"
    >
      <Icon name="dot" size={10} aria-hidden />
      <span>{label}</span>
    </button>
  );
}

export default NewMessagesPill;
